import React from "react";
import { useContext } from "react";
import { CurrencyContext } from "../features/context/CurrencyContext";

const LocationPage = () => {
    const { handleLocationSelect } = useContext(CurrencyContext);

  return (
    <div className="min-h-screen bg-[#f8f8f8] flex items-center justify-center">
      {/* Main Content */}
      <main className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="w-full lg:w-1/2 space-y-8 lg:text-left">
            <div className="space-y-4">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#02be0f] leading-tight">
                Welcome to LifeOnPlus!
              </h1>
              <h2 className="text-xl sm:text-2xl text-[#434343] font-semibold leading-relaxed">
                Your One-Stop Digital Healthcare & Wellness Marketplace
              </h2>
              <p className="text-[#474747] text-base sm:text-lg font-medium">
                Affordable | Accessible | Global Lifeline
              </p>
            </div>

            <div className="space-y-6">
              <h3 className="text-2xl sm:text-3xl font-bold text-[#303030]">
                Please select your Region
              </h3>
              <div className="space-y-3">
                <p className="text-[#474747] font-semibold text-base sm:text-lg">
                  Selecting your region helps us serve you better
                </p>
                <p className="text-[#474747] text-sm sm:text-base leading-relaxed">
                  Products, Services & Subscriptions for Prevention, Cure,
                  Recovery, and Lifestyle
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-4 justify-center lg:justify-start">
                <button
                  onClick={() => handleLocationSelect("India")}
                  className="bg-[#02be0f] hover:bg-[#128807] text-white px-6 py-2 text-base font-semibold rounded-lg flex items-center justify-center gap-2 shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="14"
                    viewBox="0 0 900 600"
                    className="shadow-sm"
                  >
                    <rect width="900" height="600" fill="#FF9933" />
                    <rect y="200" width="900" height="200" fill="#FFFFFF" />
                    <rect y="400" width="900" height="200" fill="#128807" />
                    <circle cx="450" cy="300" r="100" fill="#000080" />
                    <circle cx="450" cy="300" r="90" fill="#FFFFFF" />
                    <g fill="#000080">
                      <circle cx="450" cy="210" r="10" />
                      <circle cx="450" cy="390" r="10" />
                      <circle cx="360" cy="300" r="10" />
                      <circle cx="540" cy="300" r="10" />
                      <path d="M450,220 L450,380 M360,300 L540,300" stroke="#000080" strokeWidth="5" />
                    </g>
                  </svg>
                  INSIDE INDIA
                </button>
                <button
                  onClick={() => handleLocationSelect("Outside India")}
                  className="bg-[#02be0f] hover:bg-[#128807] text-white px-6 py-2 text-base font-semibold rounded-lg flex items-center justify-center gap-2 shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M2 12h20" />
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10" />
                    <path d="M12 2a15.3 15.3 0 0 0-4 10 15.3 15.3 0 0 0 4 10" />
                  </svg>
                  OUTSIDE INDIA
                </button>
              </div>
            </div>
          </div>

          {/* Right Illustration */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end">
            <div className="relative w-full max-w-lg sm:max-w-xl lg:max-w-3xl">
              <img
                src="/warn.png"
                alt="LifeOnPlus digital marketplace illustration showing people shopping online with laptops and shopping carts"
                className="w-full h-auto drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LocationPage;